import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useEvalNat = (evalID, classeId, refreshData, enabled, matiere = null) => {
  let urlfetch = evalID ? `${url}evaluations_nat/${evalID}` : `${url}evaluations_nat/?classes_pk=${classeId}`;

  // Si matiere est fourni (chef d'établissement), ajouter le filtre
  if (matiere && !evalID) {
    urlfetch += `&matiere=${matiere}`;
  }

  return useApi(urlfetch, [], refreshData, enabled);
};